import { createContext, useContext } from 'react'
import { TGutterValues, TResponsiveGutter } from './types'

export interface ILayoutProps {
    gutter: TGutterValues | TResponsiveGutter
}

const LayoutContext = createContext<ILayoutProps>({
    gutter: 0
})

export const useLayoutContext = () => useContext(LayoutContext)

export default LayoutContext
